import moment from 'moment-timezone';

const XTEND_MAX_TRANSMISSION_IN_HOURS = 12;

export const shouldMarkAsDelayed = (date: number): boolean => {
  if (!date) {
    return false;
  }

  const hoursSinceDate = moment.duration(moment.now() - date, 'milliseconds').asHours();
  return hoursSinceDate >= XTEND_MAX_TRANSMISSION_IN_HOURS;
};
